/**
 * 企业常用语
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getQuestionTree() {
    return request(api.answer.SPEECHTYPE + '/all', METHOD.GET);
  },
  async saveQuestionTreeDetail(params) {
    return request(api.answer.SPEECHTYPE, METHOD.POST, params);
  },
  async getQuestionTreeDetail(keyId) {
    return request(api.answer.SPEECHTYPE + "/" + keyId, METHOD.GET);
  },
  async delQuestionTree(params) {
    return request(api.answer.SPEECHTYPE + '/delete?speechTypeId=' + params, METHOD.GET);
  },
  async getKeyWords() {
    return request(api.answer.KEYWORDS + '/all', METHOD.GET);
  },
  async saveFormDetail(params) {
    return request(api.answer.SPEECH, METHOD.POST, params);
  },
  async getFormDetail(keyId) {
    return request(api.answer.SPEECH + "/" + keyId, METHOD.GET);
  }
}

export default {dataApi}